export const handleShareProduct = (product) => {
  const navigator = window.navigator;
  if (!product) return;
  const category = product?.produtCategory?.parent_category?.slug;
  const sub_category = product?.produtCategory?.name;
  const productID = product?.productID;
  const slug = product?.slug;

  const shareData = {
    title: product.productName || 'Check out this product!',
    text: product.description || 'I found this product interesting!',
    url: `${window.location.origin}${`/${category}/${sub_category}/${productID}/${slug}`}`,
  };

  try {
    if (navigator.share) {
      //  Use the native Web Share API (works on mobile & supported browsers)
      navigator.share(shareData);
    } else {
      // Fallback: Copy link to clipboard
      navigator.clipboard.writeText(shareData.url);
      alert('Link copied to clipboard!');
    }
  } catch (err) {}
};
